function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.999 511.999",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC107"
    },
    points: "108.279,102.639 108.279,65.982 11.279,159.034 108.279,252.087 108.279,215.43  345.14,215.43 345.14,102.639 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00BCD4"
    },
    points: "403.72,409.36 403.72,446.017 500.72,352.964 403.72,259.912 403.72,296.569  166.859,296.569 166.859,409.36 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M356.419,215.43V102.639c0-6.229-5.05-11.279-11.279-11.279H119.558V65.982 c0-4.52-2.698-8.603-6.855-10.376c-4.157-1.773-8.971-0.893-12.232,2.236l-97,93.052C1.253,153.023,0,155.962,0,159.034 s1.253,6.013,3.471,8.139l97,93.052c2.142,2.055,4.955,3.14,7.811,3.14c1.492,0,2.996-0.296,4.421-0.903 c4.157-1.773,6.855-5.856,6.855-10.376v-25.378H345.14C351.369,226.709,356.419,221.659,356.419,215.43z M333.861,204.151H108.279 C102.05,204.151,97,209.2,97,215.43v10.208l-69.428-66.603L97,92.433v10.206c0,6.229,5.05,11.279,11.279,11.279h225.581V204.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M508.528,344.825l-97-93.052c-3.262-3.129-8.077-4.007-12.232-2.236 c-4.157,1.773-6.855,5.856-6.855,10.376v25.378H166.859c-6.229,0-11.279,5.05-11.279,11.279v112.791 c0,6.229,5.05,11.279,11.279,11.279h225.581v25.378c0,4.52,2.698,8.603,6.855,10.376c1.427,0.608,2.93,0.905,4.421,0.903 c2.856,0,5.668-1.084,7.811-3.14l97-93.052c2.217-2.127,3.471-5.067,3.471-8.139S510.746,346.952,508.528,344.825z M415,419.567 V409.36c0-6.229-5.05-11.279-11.279-11.279H178.139v-90.233h225.581c6.229,0,11.279-5.05,11.279-11.279v-10.208l69.428,66.603 L415,419.567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M278.131,341.685h-57.523c-6.229,0-11.279,5.05-11.279,11.279c0,6.229,5.05,11.279,11.279,11.279 h57.523c6.229,0,11.279-5.05,11.279-11.279C289.41,346.735,284.36,341.685,278.131,341.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M324.375,341.685h-5.64c-6.229,0-11.279,5.05-11.279,11.279c0,6.229,5.05,11.279,11.279,11.279h5.64 c6.229,0,11.279-5.05,11.279-11.279C335.654,346.735,330.604,341.685,324.375,341.685z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M239.782,170.313h57.523c6.229,0,11.279-5.05,11.279-11.279s-5.05-11.279-11.279-11.279h-57.523 c-6.229,0-11.279,5.05-11.279,11.279S233.552,170.313,239.782,170.313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M193.538,170.313h5.64c6.229,0,11.279-5.05,11.279-11.279s-5.05-11.279-11.279-11.279h-5.64 c-6.229,0-11.279,5.05-11.279,11.279S187.308,170.313,193.538,170.313z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.b08b4d6385d20dbe904617ed3ae831f1.svg";
export { ForwardRef as ReactComponent };